(ns practitest.frontend.components2.async-status-banner
  (:require [practitest.frontend.components.icons :as icons]))

(defn async-status-banner
  [{:keys [locked? completed? stage-label percentage
           refreshing? last-refreshed-label on-refresh on-dismiss
           title completed-title message completed-message
           refresh-label dismiss-label]}]
  (let [show? (or locked? completed?)]
    (when show?
      [:div.async-status-banner.alert.alert-info
       {:class (when completed? "async-status-completed")}
       [:div.async-status-banner-content
        [:span.async-status-icon
         (if completed?
           [:i.fa.fa-check-circle]
           [icons/info-circle-fill])]
        [:div.async-status-text
         (if completed?
           [:<>
            [:strong completed-title]
            [:span completed-message]]
           [:<>
            [:strong title]
            [:span message]
            (let [display-pct (or percentage 0)]
              [:div.async-status-progress
               [:span.async-status-stage stage-label]
               [:div.async-progress-bar-container
                [:div.async-progress-bar {:style {:width (str display-pct "%")}}]]
               [:span.async-progress-percentage (str display-pct "%")]])])]
        (if completed?
          [:div.async-status-refresh-area
           [:button.btn.btn-link.async-status-refresh
            {:on-click #(when on-dismiss (on-dismiss))}
            [:i.fa.fa-times]
            [:span (or dismiss-label "Dismiss")]]]
          [:div.async-status-refresh-area
           [:button.btn.btn-link.async-status-refresh
            {:on-click #(when (and on-refresh (not refreshing?)) (on-refresh))
             :disabled refreshing?}
            [:span {:class (when refreshing? "async-refresh-spinning")}
             [icons/mux-refresh]]
            [:span (or refresh-label "Refresh")]]
           (when last-refreshed-label
             [:span.async-status-last-refreshed last-refreshed-label])])]])))
